import { render, staticRenderFns } from "./resdetails.vue?vue&type=template&id=97b9d63c&scoped=true&"
import script from "./resdetails.vue?vue&type=script&lang=js&"
export * from "./resdetails.vue?vue&type=script&lang=js&"
import style0 from "./resdetails.vue?vue&type=style&index=0&id=97b9d63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b9d63c",
  null
  
)

export default component.exports